<template>
  <div class="card card-profile mt-2">
    <div class="card-body">
      <div class="text-left">
        <a :href="document.file_url" target="_blank">
          <h5>{{ document.title }}</h5>
          <div class="h6 font-weight-300">{{ document.description }}</div>
        </a>
      </div>
      <div
        class="
          d-flex
          flex-row
          bd-highlight
          align-items-center
          justify-content-end
        "
      >
        <div class="bd-highlight">
          <button
            class="btn btn-link text-danger text-gradient px-3 m-0"
            @click="showAlert"
          >
            <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
            Eliminar
          </button>
        </div>
        <div class="bd-highlight">
          <router-link
            :to="`/document-card/${document.id}`"
            class="btn btn-link text-dark px-3 m-0"
          >
            <i class="fas fa-pencil-alt text-dark me-2" aria-hidden="true"></i
            >Editar
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "documents-table",
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deleteDocument() {
      this.plain
        .delete(`/documents/${this.document.id}`)
        .then(() => {
          this.$parent.deleteItemDocument(this.document.id);
        })
        .catch((error) => {
          console.log("Error al eliminar DOCUMENT", error);
        });
    },
    showAlert() {
      //deleteUser(user.id)
      this.$swal.fire({
        title: '¿Está seguro?',
        text: "¡No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteDocument();
          this.$swal.fire(
            '¡Eliminado!',
            'El Documento ha sido eliminado.',
          )
        }
      })
    }
  },
};
</script>